import { useState } from 'react';

import type { TSkeletonConfig, TSkeletonLogicResult, TSkeletonItem } from './skeleton.types';

let skeletonCounter = 0;

export const useSkeletonLogic = ({ numOfElements = 1 }: Pick<TSkeletonConfig, 'numOfElements'>): TSkeletonLogicResult => {
	const [items] = useState<TSkeletonItem[]>(() =>
		Array.from({ length: numOfElements }, (_item, index) => ({
			key: `skeleton-${++skeletonCounter}`,
			unSyncedAnimationTime: ((index % 3) + 1) * 90 + 800,
			index,
		}))
	);

	return { items };
};
